import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { mapEasingToNativeEasing } from 'motion-dom';
function startWaapiAnimation(element, valueName, keyframes) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 300 : _ref$duration,
    _ref$repeat = _ref.repeat,
    repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
    _ref$ease = _ref.ease,
    ease = _ref$ease === void 0 ? "easeInOut" : _ref$ease,
    times = _ref.times;
  var keyframeOptions = _defineProperty({}, valueName, keyframes);
  if (times) keyframeOptions.offset = times;
  var easing = mapEasingToNativeEasing(ease, duration);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */
  if (Array.isArray(easing)) keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay,
    duration: duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
export { startWaapiAnimation };